/**
 * Helper function to download file
 * @param {string} filename filename with extension
 * @param {string} data Blob or href string
 */
export function saveAs(filename, data) {
  const a = document.createElement('a');
  a.rel = 'noopener';
  a.download = filename;
  // eslint-disable-next-line compat/compat
  a.href = data instanceof Blob ? URL.createObjectURL(data) : data;
  a.dispatchEvent(new MouseEvent('click'));
  // eslint-disable-next-line compat/compat
  URL.revokeObjectURL(a.href);
}
